import React, { useRef } from 'react'
import MatAccordion from '@material-ui/core/Accordion'
import { styled } from '@material-ui/core/styles'

const StyledAccordion = styled(MatAccordion)({
  '&:before': {
    height: 0
  },
  boxShadow: 'none',
  backgroundColor: '#FFF'
})

export function Accordion ({
  className,
  children,
  isScrolling = true,
  isExpandedOnStart = false
}) {
  const ref = useRef()

  const handleChange = (event, isExpanded) => {
    if (isExpanded && isScrolling) {
      setTimeout(() => {
        window.scrollTo({
          top: ref.current.offsetTop,
          behavior: 'smooth'
        })
      }, 200)
    }
  }

  return (
    <StyledAccordion
      className={className}
      onChange={handleChange}
      defaultExpanded={isExpandedOnStart}
      ref={ref}
    >
      {children}
    </StyledAccordion>
  )
}
